import { cn } from '@/lib/utils';
import { Input } from '@/libs/components/src/lib/form/Input';

import { Icon } from '@chiroup/components/Icon';
import { Icons } from '@chiroup/components/icons';
import React from 'react';
import IconButton from '../../../../common/IconButton';

interface InlineAssessmentInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
  inputName?: string;
  inputClassName?: string;
  formClassName?: string;
}

const InlineAssessmentInput: React.FC<InlineAssessmentInputProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder = 'Enter explanation',
  inputName = 'assessment-explanation',
  inputClassName = 'w-48',
  formClassName = '',
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form
      className={cn('inline-flex items-center gap-1 ml-2', formClassName)}
      onSubmit={handleSubmit}
    >
      <Input
        name={inputName}
        type="text"
        inputClassName={cn('!h-6 focus-visible:ring-[1px]', inputClassName)}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoFocus
      />
      <IconButton
        type="submit"
        className="w-6 h-6 text-primary-600 hover:bg-gray-200 dark:hover:bg-dark-gray-700 rounded"
        aria-label="save explanation"
        icon={<Icon icon={Icons.check} className="w-4 h-4" />}
      />
    </form>
  );
};

export default InlineAssessmentInput;
